import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import Api from 'entities/api';

const usePayPalCommerce = () => {
  const [loading, setLoading] = useState(false);
  const [actionUrl, setActionUrl] = useState<string | undefined>(undefined);
  const [error, setError] = useState(false);

  const fetchPayPalCommerceUrl = () => {
    setLoading(true);
    setError(false);

    const subscription = Api.post<{ actionUrl?: string }>(
      'api/organizations/payPalCommerce'
    ).subscribe(
      (data) => {
        if (data && data.actionUrl) {
          setActionUrl(data.actionUrl);
        } else {
          setError(true);
        }
        setLoading(false);
      },
      () => {
        setError(true);
        setLoading(false);
      }
    );
    return () => subscription.unsubscribe();
  };

  return { loading, error, actionUrl, fetchPayPalCommerceUrl };
};

export const PayPalCommerceLink = () => {
  const { loading, error, actionUrl, fetchPayPalCommerceUrl } = usePayPalCommerce();
  const paypalUrl = actionUrl ? `${actionUrl}&displayMode=minibrowser` : undefined;

  useEffect(() => {
    if (paypalUrl) {
      window.open(paypalUrl, '_blank');
    }
  }, [paypalUrl]);

  if (paypalUrl) {
    return (
      <Button size="large" color="primary" variant="contained" href={paypalUrl} target="_blank">
        Connect to PayPal Commerce
      </Button>
    );
  }

  let startIcon;
  if (loading) {
    startIcon = <CircularProgress size="1rem" />;
  } else if (error) {
    startIcon = (
      <Tooltip title="There has been an error trying to initiate PayPal Commerce for your organization">
        <ErrorIcon />
      </Tooltip>
    );
  }

  return (
    <Stack spacing={2} alignItems="start">
      <Button
        color="primary"
        variant="contained"
        size="large"
        onClick={fetchPayPalCommerceUrl}
        startIcon={startIcon}
        disabled={loading}
      >
        Connect to PayPal Commerce
      </Button>
    </Stack>
  );
};
